import { CONSTANTS } from "../constants/callcentral.constants";
import { StorageService } from "./storage.service";
import { utilService } from "./utilService";

const getRolePermissionsDetails = () => {
  const savePassword = utilService.getSavePasswordStatus();
  const rolePermissionData = StorageService.getStorageItem(
    CONSTANTS.STORAGE[true === savePassword ? 1 : 0],
    "rolePermissions",
    true
  );
  return JSON.parse(rolePermissionData);
};

export const rolePermissionsService = {
  getRolePermissionsDetails,
};
